/* @flow */
import React, { Component, PureComponent } from 'react'
import Tooltip from 'antd/lib/tooltip'
import moment from 'moment'
import type { DateRange } from './Chart'
import type { Lang } from './App'
import labels from './labels'

const slots = [
  { months: 3, label: 'slot3', content: '3' },
  { months: 6, label: 'slot6', content: '6' },
  { months: 9, label: 'slot9', content: '9' },
  { months: 12, label: 'slot12', content: '12' },
  { months: 36, label: 'slot36', content: '36' },
  { months: 0, label: 'slotMax', content: 'max' }
]

type Props = {
  range: DateRange,
  maxRange: DateRange,
  timeSlot: ?number,
  lang: Lang,
  filterDate: (range: DateRange, m: ?number) => void,
}
class TimeSlots extends Component<Props> {
  shouldComponentUpdate = ({ timeSlot }: Props) => timeSlot !== this.props.timeSlot

  filterDate = (m: number) => (e: SyntheticEvent<HTMLButtonElement>) => {
    const { range: [, endDate], maxRange: [minDate, maxDate], filterDate } = this.props
    if (m) {
      const first = moment(endDate).subtract(m, 'months')
      const isLeftOut = first.isBefore(moment(minDate))
      filterDate([isLeftOut ? minDate : first.toDate(), endDate], isLeftOut ? null : m)
    } else {
      filterDate([minDate, maxDate], m)
    }
  }

  render = () => {
    const { timeSlot, lang } = this.props
    return (
    <div className="ui primary buttons">
      {slots.map(({ months, label, content }) => 
      <TimeSlot
        key={months}
        popup={labels[lang][label]}
        content={content}
        active={timeSlot === months}
        onClick={this.filterDate(months)}
      />)}
    </div>
    )
  }
}

export default TimeSlots

type TimeSlotProps = {
  active: boolean,
  content: string,
  popup: string,
  onClick: (e: SyntheticEvent<HTMLButtonElement>) => void
}
class TimeSlot extends PureComponent<TimeSlotProps> {
  render() {
    const { active, onClick, content, popup } = this.props
    return (
      <Tooltip title={popup}>
        <button
          className={`${active ? 'active' : ''} ui button`}
          onClick={onClick}>
          {content}
        </button>
      </Tooltip>
    )
  }
}






// WEBPACK FOOTER //
// ./src/TimeSlots.js